module.exports = "//d274d294w9cx2v.cloudfront.net/800c95db52dfbdbd8df23bcfa3c73613d087d409/images/payPalBadge.png";